import { render } from "./HeadingApplications.vue?vue&type=template&id=56a1c146&scoped=true"
import script from "./HeadingApplications.vue?vue&type=script&lang=js"
export * from "./HeadingApplications.vue?vue&type=script&lang=js"

import "./HeadingApplications.vue?vue&type=style&index=0&id=56a1c146&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a1c146"]])

export default __exports__